$(document).ready(function () {
  
  $(window).scroll(function (event) {
    var height = $(window).height();
    var scroll = $(window).scrollTop();
      if(scroll > height){
        $(".sticky-header").addClass("show");
      } else {
        $(".sticky-header").removeClass("show");
      } 
  });
  
  const max_allowed = document.querySelector('#checkboxes').getAttribute("max_allowed");
  $("#submit-btn").click(function () {
    $("#flexi-box-form")
      .find(":input")
      .each(function () {
        if ($(this).val() == "No") {
          $(this).prop("disabled", true);
        }
      });
    $(this).submit();
  });

  let checkboxes = $("input[type='checkbox']"),
    submitBtn = $("#submit-btn");

  checkboxes.click(function () {
    var n = $("input:checked").length;
    if (n == max_allowed) {
      submitBtn.css("display", "inline-block");
    } else {
      submitBtn.css("display", "none");
    }
    
    if(n>0){
      $("#checkbox_count").css("display", "inline-block");
      $("#checkbox_count").html(n);
    }
    else{
      $("#checkbox_count").css("display", "none");
    }
    
    $.each(checkboxes, function () {
      if (!$(this).is(":checked") && n == max_allowed) {
        $(this).prop("disabled", true);
      } else {
        $(this).prop("disabled", false);
      }
    });
  });
  
});

// json format change by Anshika Arora 
//   document.addEventListener('DOMContentLoaded', function () {
//     const form = document.querySelector('#flexi-box-form');
//     const dynamicPropertiesContainer = document.querySelector('#dynamic-properties');
//     const checkboxes = document.querySelectorAll('.product-checkbox');
    
//     //fetch byob parent info 
//     const byobParentSku = form.dataset.byobParentSku;
//     const parentPrice = parseFloat(form.dataset.byobParentPrice);
    
//     console.log('BYOB Parent SKU:', byobParentSku);
//     console.log('Parent Price:', parentPrice);

//     function updateProportionalPrices() {
//   dynamicPropertiesContainer.innerHTML = '';

//   const selectedCheckboxes = Array.from(checkboxes).filter((cb) => cb.checked);
  
//   console.log('Selected checkboxes:', selectedCheckboxes.length);
  
//   if (selectedCheckboxes.length === 0) return;

//   // Calculate total regular price using price
//   const totalRegularPrice = selectedCheckboxes.reduce((sum, cb) => {
//     const price = parseFloat(cb.dataset.price || 0);
//     return sum + price;
//   }, 0);

//   console.log('Total Regular Price:', totalRegularPrice);

//   // First, create all _ITEM properties
//   // selectedCheckboxes.forEach((checkbox, index) => {
//   //   const sku = checkbox.dataset.sku;
//   //   const productTitle = checkbox.dataset.productTitle;
//   //   const variantId = checkbox.dataset.variantId;
    
//   //   const itemInput = document.createElement('input');
//   //   itemInput.type = 'hidden';
//   //   itemInput.name = `properties[_ITEM${index + 1}]`;
//   //   itemInput.value = `${productTitle}/${sku}/${variantId}`;
//   //   dynamicPropertiesContainer.appendChild(itemInput);
//   // });

//   const parentQuantity = parseInt(form.dataset.byobParentQuantity) || 1;

//   // Then, create _bundle_product1 (parent BYOB product)
//   const bundleProduct1 = document.createElement('input');
//   bundleProduct1.type = 'hidden';
//   bundleProduct1.name = 'properties[_bundle_product1]';
//   bundleProduct1.value = `${byobParentSku}/0/${parentQuantity}`;
//   dynamicPropertiesContainer.appendChild(bundleProduct1);

//   // Finally, create all other _bundle_product properties (child products)
//   selectedCheckboxes.forEach((checkbox, index) => {
//     const price = parseFloat(checkbox.dataset.price || 0);
//     const proportionalPrice = parseFloat(((price / totalRegularPrice) * parentPrice).toFixed(2));
//     const sku = checkbox.dataset.sku;
    
//     console.log(`Item ${index + 1}:`, { 
//       sku, 
//       price, 
//       proportionalPrice 
//     });
    
//     const bundleInput = document.createElement('input');
//     bundleInput.type = 'hidden';
//     bundleInput.name = `properties[_bundle_product${index + 2}]`;
//     bundleInput.value = `${sku}/${proportionalPrice}/1`;
//     dynamicPropertiesContainer.appendChild(bundleInput);
//   });
  
//   console.log('Generated properties:', dynamicPropertiesContainer.innerHTML);
// }

//     checkboxes.forEach((checkbox) => {
//       checkbox.addEventListener('change', updateProportionalPrices);
//     });

//     form.addEventListener('submit', function(e) {
//       updateProportionalPrices();
      
//       const formData = new FormData(form);
//       console.log('=== Form Data Being Submitted ===');
//       for (let [key, value] of formData.entries()) {
//         console.log(key, ':', value);
//       }
//     });
//   });
  
